import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiStar } = FiIcons;

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: "Rajesh Sharma",
      company: "CEO of IT Company",
      quote: "Advertising Pandit completely transformed our sales pipeline. Their AI-driven ads brought us more qualified leads than ever before.",
      photo: "https://i.postimg.cc/xjHscRqQ/Whats-App-Image-2026-01-13-at-3-53-59-PM.jpg"
    },
    {
      name: "Priya Patel",
      company: "Marketing Director, Fashion Brand",
      quote: "The ROI we've seen from their campaigns is incredible. Our conversion rates have tripled in just 3 months.",
      photo: "https://i.postimg.cc/7L8hYwRx/Whats-App-Image-2026-01-13-at-3-55-45-PM.jpg"
    },
    {
      name: "Amit Kumar",
      company: "Founder, Tech Startup",
      quote: "Their creative team and data-driven approach helped us scale from startup to market leader.",
      photo: "https://i.postimg.cc/JnGRNhG7/Whats-App-Image-2026-01-13-at-4-26-37-PM.jpg"
    }
  ];

  const cardVariants = {
    offscreen: { y: 50, opacity: 0 },
    onscreen: { 
      y: 0, 
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.4,
        duration: 0.8
      }
    },
    hover: {
      y: -10,
      boxShadow: "0 20px 30px rgba(177, 107, 189, 0.3)",
      transition: {
        type: "spring",
        stiffness: 300,
        damping: 10
      }
    }
  };

  return (
    <section className="py-24 relative" style={{ backgroundColor: '#3a1c40' }}>
      {/* Animated background */}
      <div className="absolute inset-0 overflow-hidden">
        <motion.div 
          className="absolute top-0 w-full h-full opacity-10"
          style={{
            background: 'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%23b16bbd\' fill-opacity=\'0.4\'%3E%3Cpath d=\'M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
          }}
          animate={{
            backgroundPosition: ['0px 0px', '60px 60px'],
          }}
          transition={{
            duration: 20,
            repeat: Infinity,
            ease: "linear"
          }}
        />
        <motion.div 
          className="absolute bottom-0 right-1/4 w-96 h-96 rounded-full opacity-20"
          style={{
            background: 'radial-gradient(circle, rgba(255, 215, 0, 0.4) 0%, rgba(58, 28, 64, 0) 70%)',
            filter: 'blur(60px)'
          }}
          animate={{
            scale: [1, 1.3, 1],
            opacity: [0.2, 0.3, 0.2]
          }}
          transition={{
            duration: 10,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <motion.div
          initial={{ y: 30, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-purple-300 to-yellow-300 bg-clip-text text-transparent">
            What Our Clients Say
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              variants={cardVariants}
              initial="offscreen"
              whileInView="onscreen"
              whileHover="hover"
              viewport={{ once: true, amount: 0.1 }}
              className="bg-purple-900 bg-opacity-30 rounded-2xl p-8 backdrop-blur-sm border border-purple-700"
            >
              <motion.div 
                className="flex items-center mb-4"
                animate={{
                  color: ['#FFD700', '#ffeaa0', '#FFD700'],
                }}
                transition={{
                  duration: 3,
                  repeat: Infinity,
                  ease: "easeInOut",
                  delay: index * 0.3
                }}
              >
                {[...Array(5)].map((_, i) => (
                  <SafeIcon key={i} icon={FiStar} className="text-lg mr-1 fill-current" />
                ))}
              </motion.div>
              <blockquote className="text-purple-100 mb-6 italic leading-relaxed">
                "{testimonial.quote}"
              </blockquote>
              <div className="flex items-center">
                <motion.img 
                  src={testimonial.photo} 
                  alt={testimonial.name} 
                  className="w-12 h-12 rounded-full mr-4 object-cover border-2"
                  style={{ borderColor: '#FFD700' }}
                  whileHover={{ scale: 1.1 }}
                />
                <div>
                  <h4 className="font-semibold text-yellow-300">
                    {testimonial.name}
                  </h4>
                  <p className="text-sm text-purple-300">{testimonial.company}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;